import { ATTRIBUTE_TYPE } from '../config';

var getAboutOurFabricsButton = function getAboutOurFabricsButton(pageType) {
  return {
    eventInfo: {
      eventAction: 'About our fabrics',
      eventName: "".concat(pageType, "_mtoSideDrawerCtaClick")
    }
  };
};

export var getCloseIcon = function getCloseIcon(pageType, choiceType) {
  return {
    eventInfo: {
      eventAction: "".concat(choiceType, " choice closed"),
      eventName: "".concat(pageType, "_mtoSideDrawer"),
      extraDetails: 'close icon click'
    }
  };
};
export var getCloseOverlay = function getCloseOverlay(pageType, choiceType) {
  return {
    eventInfo: {
      eventAction: "".concat(choiceType, " choice closed"),
      eventName: "".concat(pageType, "_mtoSideDrawer"),
      extraDetails: 'grey area click'
    }
  };
};
export var getOpenDrawer = function getOpenDrawer(pageType, choiceType) {
  return {
    eventInfo: {
      eventAction: "".concat(choiceType, " choice open"),
      eventName: "".concat(pageType, "_mtoSideDrawer")
    }
  };
};

function isValidPageType(pageType) {
  return typeof pageType === 'string' && pageType !== '';
}

export var trackAboutOurFabricsButton = function trackAboutOurFabricsButton(pageType) {
  if (window.digitalData && isValidPageType(pageType)) {
    var _window$digitalData$t, _window$digitalData;

    if (!window.digitalData.event) window.digitalData.event = [];
    window.digitalData.event.push(getAboutOurFabricsButton(pageType));
    (_window$digitalData$t = (_window$digitalData = window.digitalData).track) === null || _window$digitalData$t === void 0 ? void 0 : _window$digitalData$t.call(_window$digitalData, getAboutOurFabricsButton(pageType).eventInfo.eventName);
  }
};
export var getType = function getType(attributeType) {
  return attributeType.toLocaleLowerCase() === ATTRIBUTE_TYPE.FABRIC_TYPE ? 'fabric' : 'legs';
};
export var getEventData = function getEventData(pageType, attributeType, onCloseType) {
  var closeType = getType(attributeType);

  switch (onCloseType) {
    case 'icon':
      return getCloseIcon(pageType, closeType);

    case 'overlay':
      return getCloseOverlay(pageType, closeType);

    default:
      return null;
  }
};
export var trackCloseDrawerEvent = function trackCloseDrawerEvent(pageType, attributeType, onCloseType) {
  if (window.digitalData && isValidPageType(pageType)) {
    var _window$digitalData$t2, _window$digitalData2;

    if (!window.digitalData.event) window.digitalData.event = [];
    var eventData = getEventData(pageType, attributeType, onCloseType);
    if (!eventData) return;
    window.digitalData.event.push(eventData);
    (_window$digitalData$t2 = (_window$digitalData2 = window.digitalData).track) === null || _window$digitalData$t2 === void 0 ? void 0 : _window$digitalData$t2.call(_window$digitalData2, eventData.eventInfo.eventName);
  }
};
export var trackOpenDrawerEvent = function trackOpenDrawerEvent(pageType, attributeType) {
  var openType = getType(attributeType);

  if (window.digitalData && isValidPageType(pageType)) {
    var _window$digitalData$t3, _window$digitalData3;

    if (!window.digitalData.event) window.digitalData.event = [];
    var eventData = getOpenDrawer(pageType, openType);
    window.digitalData.event.push(eventData);
    (_window$digitalData$t3 = (_window$digitalData3 = window.digitalData).track) === null || _window$digitalData$t3 === void 0 ? void 0 : _window$digitalData$t3.call(_window$digitalData3, eventData.eventInfo.eventName);
  }
};